export function easyscroll() {
    $(".easyscroll").on("click", function (event) {
        event.preventDefault();
        let id  = $(this).attr("href");
        if($(id).length){ 
            let top = $(id).offset().top - $(".header").outerHeight() - 10;
            $("body,html").stop().animate({scrollTop: top}, 600);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/easyscroll.js